import { render, staticRenderFns } from "./CQPagination.vue?vue&type=template&id=0490fc7f&scoped=true&"
import script from "./CQPagination.vue?vue&type=script&lang=js&"
export * from "./CQPagination.vue?vue&type=script&lang=js&"
import style0 from "./CQPagination.vue?vue&type=style&index=0&id=0490fc7f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0490fc7f",
  null
  
)

export default component.exports